import React from 'react';
import Navbar from './global-components/navbar-v4';
import PageHeader from './global-components/page-header';
import Contact from './section-components/contact';
import Footer from './global-components/footer';

const Career = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Career"  />
        <Contact />
        <Footer />
    </div>
}

export default Career

